import requestAll from './request.js';

// const webUrl = '域名'
// const baseUrl = apiUrl + '?act='

export function deleteCharge(data) {
    let param = {
        url: "/deleteCharge",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getChargeList(data) {
    let param = {
        // url: `/getChargeList`,
        url: `/getChargeList?startDate=${data.startDate}&endDate=${data.endDate}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addChargeItem(data) {
    let param = {
        url: "/addChargeItem",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getBakingList(data) {
    let param = {
        url: `/getBakingList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function updateBaking(data) {
    let param = {
        url: "/updateBaking",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteBaking(data) {
    let param = {
        url: "/deleteBaking",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getBakingMaterialList(data) {
    let param = {
        url: `/getBakingMaterialList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addBakingMaterial(data) {
    let param = {
        url: "/addBakingMaterial",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteBakingMaterial(data) {
    let param = {
        url: "/deleteBakingMaterial",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getUnitList(data) {
    let param = {
        url: `/getUnitList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addUnit(data) {
    let param = {
        url: "/addUnit",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteUnit(data) {
    let param = {
        url: "/deleteUnit",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getWeightList(data) {
    let param = {
        url: `/getWeightList?role=${data.role}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function recordWeight(data) {
    let param = {
        url: "/recordWeight",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteWeightRecord(data) {
    let param = {
        url: "/deleteWeight",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getTotalListByDate(data) {
    let param = {
        url: `/getTotalListByDate?startDate=${data.startDate}&endDate=${data.endDate}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getList(data) {
    let param = {
        url: `/getList?startDate=${data.startDate}&endDate=${data.endDate}${data?.isAsc?'&isAsc=true': ''}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addEatRecord(data) {
    let param = {
        url: "/addRecord",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteEatRecord(data) {
    let param = {
        url: "/deleteRecord",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getSleepList(data) {
    let param = {
        url: `/getSleepList?startDate=${data.startDate}&endDate=${data.endDate}${data?.isAsc?'&isAsc=true': ''}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addSleepRecord(data) {
    let param = {
        url: "/addSleepRecord",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteSleepRecord(data) {
    let param = {
        url: "/deleteSleepRecord",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getSportList(data) {
    let param = {
        url: `/getSportList?startDate=${data.startDate}&endDate=${data.endDate}${data?.isAsc?'&isAsc=true': ''}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addSportRecord(data) {
    let param = {
        url: "/addSportRecord",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getTotalSportListByDate(data) {
    let param = {
        url: `/getTotalSportListByDate?startDate=${data.startDate}&endDate=${data.endDate}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function deleteSPortRecord(data) {
    let param = {
        url: "/deleteSportRecord",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getMenuTypeList(data) {
    let param = {
        url: `/getMenuTypeList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addMenuType(data) {
    let param = {
        url: "/addMenuType",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteMenuType(data) {
    let param = {
        url: "/deleteMenuType",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function modifyMenu(data) {
    let param = {
        url: "/modifyMenu",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteMenu(data) {
    let param = {
        url: "/deleteMenu",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getMenuNameList(data) {
    let param = {
        url: `/getMenuNameList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getMenuNameListByType(data) {
    let param = {
        url: `/getMenuNameListByType?type=${data.type}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getMenuList(data) {
    let param = {
        url: `/getMenuList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getMenuDetail(data) {
    let param = {
        url: `/getMenuDetail?id=${data.id}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getWeeklyRecipes(data) {
    let param = {
        url: `/getWeeklyRecipes?startDate=${data.startDate}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addWeeklyRecipes(data) {
    let param = {
        url: "/updateWeeklyRecipes",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function updateWeeklyRecipes(data) {
    let param = {
        url: "/updateWeeklyRecipes",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getUserPreference(data) {
    let param = {
        url: `/getUserPreference`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function updateUserPreference(data) {
    let param = {
        url: "/updateUserPreference",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getMemoRandumList(data) {
    let param = {
        url: `/getMemoRandumByType?type=${data.type}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function updateMemoRandum(data) {
    let param = {
        url: "/modifyMemorandum",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteMemoRandum(data) {
    let param = {
        url: "/deleteMemoRandum",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getGoldPrice(data) {
    let param = {
        url: `/getGoldPrice`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function uploadFile(data) {
    let param = {
        url: "/uploadImg",
        method: "post",
        data: data
    }
    return requestAll.requestFile(param);
}

export function updateTopic(data) {
    let param = {
        url: "/updateTopic",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteTopic(data) {
    let param = {
        url: "/deleteTopic",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}


export function getTopic(data) {
    let param = {
        url: `/getTopic?id=${data.id}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getTopicNameList(data) {
    let param = {
        url: `/getTopicNameList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getIpSaveList(data) {
    let param = {
        url: `/getIpSave`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getMiaotixingList(data) {
    let param = {
        url: `/getMiaotixingList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getMiaotixingConfig(data) {
    return getMiaotixingList(data);
}

export function saveMiaotixingConfig(data) {
    let param = {
        url: "/saveMiaotixingConfig",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteMiaotixingConfig(data) {
    let param = {
        url: "/deleteMiaotixingConfig",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function completeMiaotixingToday(data) {
    let param = {
        url: "/completeMiaotixingToday",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getTodayFoodRecommendation(data) {
    let param = {
        url: `/getTodayFoodRecommendation`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function refreshTodayFoodRecommendation(data) {
    let param = {
        url: `/refreshTodayFoodRecommendation`,
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function generateEnglishDialogue(data) {
    let param = {
        url: "/generateEnglishDialogue",
        method: "post",
        data: data,
        timeout: 120000,
    }
    return requestAll.request(param);
}

export function getEnglishTopicSuggestions(params = {}) {
    const qs = new URLSearchParams();
    if (params.level) qs.set("level", params.level);
    if (params.refresh) qs.set("refresh", "true");
    if (params.exclude && params.exclude.length) {
        qs.set("exclude", params.exclude.join(","));
    }
    const query = qs.toString();
    let param = {
        url: `/getEnglishTopicSuggestions${query ? `?${query}` : ""}`,
        method: "get"
    }
    return requestAll.request(param);
}

export function getHomeMemoryList(data = {}) {
    const qs = new URLSearchParams();
    if (data.startDate) qs.set("startDate", data.startDate);
    if (data.endDate) qs.set("endDate", data.endDate);
    const query = qs.toString();
    let param = {
        url: `/getHomeMemoryList${query ? `?${query}` : ""}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addHomeMemory(data) {
    let param = {
        url: "/addHomeMemory",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteHomeMemory(data) {
    let param = {
        url: "/deleteHomeMemory",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getDeviceKeyList(data) {
    let param = {
        url: `/getDeviceKeyList`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getDeviceKey(data) {
    const qs = new URLSearchParams();
    if (data.id) qs.set("id", data.id);
    if (data.authKey) qs.set("authKey", data.authKey);
    const query = qs.toString();
    let param = {
        url: `/getDeviceKey${query ? `?${query}` : ""}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addDeviceKey(data) {
    let param = {
        url: "/addDeviceKey",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function updateDeviceKey(data) {
    const qs = new URLSearchParams();
    if (data.id) qs.set("id", data.id);
    if (data.deviceName) qs.set("deviceName", data.deviceName);
    if (data.authKey) qs.set("authKey", data.authKey);
    const query = qs.toString();
    let param = {
        url: `/updateDeviceKey${query ? `?${query}` : ""}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function deleteDeviceKey(data) {
    let param = {
        url: "/deleteDeviceKey",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function updateDeviceKeyRemark(data) {
    let param = {
        url: "/updateDeviceKeyRemark",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getDeviceKeyUpdateList(data = {}) {
    const qs = new URLSearchParams();
    if (data.authKey) qs.set("authKey", data.authKey);
    if (data.page != null) qs.set("page", String(data.page));
    if (data.pageSize != null) qs.set("pageSize", String(data.pageSize));
    const query = qs.toString();
    let param = {
        url: `/getDeviceKeyUpdateList${query ? `?${query}` : ""}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getDeviceKeyAccessList(data = {}) {
    const qs = new URLSearchParams();
    if (data.authKey) qs.set("authKey", data.authKey);
    if (data.page != null) qs.set("page", String(data.page));
    if (data.pageSize != null) qs.set("pageSize", String(data.pageSize));
    const query = qs.toString();
    let param = {
        url: `/getDeviceKeyAccessList${query ? `?${query}` : ""}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function getAccountVaultList(data = {}) {
    const qs = new URLSearchParams();
    if (data.keyword) qs.set("keyword", data.keyword);
    const query = qs.toString();
    let param = {
        url: `/getAccountVaultList${query ? `?${query}` : ""}`,
        method: "get",
        data: data
    }
    return requestAll.request(param);
}

export function addAccountVault(data) {
    let param = {
        url: "/addAccountVault",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function updateAccountVault(data) {
    let param = {
        url: "/updateAccountVault",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function deleteAccountVault(data) {
    let param = {
        url: "/deleteAccountVault",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function login(data) {
    let param = {
        url: "/login",
        method: "post",
        data: data
    }
    return requestAll.request(param);
}

export function getMe() {
    let param = {
        url: "/me",
        method: "get"
    }
    return requestAll.request(param);
}
